import { SessionModeEnum } from '@/enums/SessionModeEnum';

export default {
    title: '课',
    buttons: {
        start: '开始上课',
        end: ({ values }: { values: { mode: SessionModeEnum } }) => {
            const { mode } = values;
            return mode === SessionModeEnum.SELF ? '结束自学' : '结束上课';
        },
        exit: '退出',
        review: '查看',
        pause: '暂停',
        resume: '继续',
        selfModeDoneConfirm: '确定要结束自学吗？<br />如果有尚未完成的学生，目前为止的学习记录将会被保存。',
        selfDoneConfirm: '自学仍在进行中，确定要结束吗？<br />即使结束自学，目前为止的学习记录仍会保存。',
        selfDoneConfirmMessage: '自学模式已完成！',
        goStudentPage: '前往等候室',
        goTaskResult: '查看结果',
    },
    modal: {
        title: {
            ongoing: '活动进行中',
            completed: '结束上课',
        },
        message: {
            ongoing: '结束上课时，正在进行的活动也会一起结束。\n确定要结束吗？',
            completed: '确定要结束上课吗？',
        },
    },
    status: {
        ongoing: '进行中',
        completed: '已完成',
        paused: '已暂停',
        preparing: '准备中',
        waiting: '等待中',
    },

    timer: {
        format: '{minutes}:{seconds}',
        started: '于{time}开始',
        duration: '已进行{duration}分钟',
    },

    students: {
        online: '在线',
        offline: '离线',
        total: '全部',
        count: '{count}名',
        countFormat: '{online}/{total}',
        selectAll: '全选',
        selected: '已选择',
        unselected: '取消选择',
        notSubmitted: '未提交学生',
    },

    screen: {
        toggle: '黑板屏幕',
        on: 'ON',
        off: 'OFF',
        options: {
            none: '不使用',
            basic: '主屏幕',
            waitingRoom: '等候室',
            activity: '活动屏幕',
            sessionResult: '课结果屏幕',
            moduleResult: '活动结果屏幕',
        },
    },

    focus: {
        toggle: '专注模式',
        on: '专注模式已开启',
        off: '专注模式已关闭',
    },

    star: {
        title: '表扬星',
        give: '赠送表扬星',
        comment: '表扬留言',
        comments: {
            great: '做得好！',
            excellent: '太棒了！',
            good: '不错！',
            perfect: '完美！',
            amazing: '了不起！',
        },
    },

    module: {
        start: '开始活动',
        end: '结束活动',
        setting: '活动设置',
        preview: '预览',
        result: '查看结果',
        inProgress: '活动进行中',
        completed: '活动已完成',
        fold: '折叠写作素材',
        subject: '写作素材',
    },

    navigation: {
        home: '返回首页',
        waitingRoom: '前往等候室',
        result: '查看结果',
        next: '下一个活动',
        previous: '上一个活动',
    },
};
